/* global firebase_path, session_id, merchant_id, firebase, table_id */
import React, { Component } from 'react';
import TopNav from '../components/TopNav';
import Order from '../Model/Order';
import MenuItemModal from './modal/MenuItemModal';
import MessageModal from './modal/MessageModal';
import ConfirmModal from './modal/ConfirmModal';
import {pageReload} from '../util/PageReload';
import { Redirect } from 'react-router-dom';
import { TableType } from '../components/merchant/Enum/TableType';
import MenuItemThumbnailImage from './components/MenuItemThumbnailImage'
import { OrderUtil, PayBillHint } from './Order';
import ReactHelper from '../util/ReactHelper';
import SelectedSideDishListing from '../app/User/Order/SelectedSideDishListing';
import SelectedVariationListing from '../app/User/Order/SelectedVariationListing';

const OrderBy = {
    USER:   1,
    ADMIN:  2
}

class NewOrderContent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            confirmOrder: [],
            draftOrder: [],
            menuItems: [],
            variations: [],
            addons: [],
            options: [],
            selectedAddOns: [],
            selectedOptions: [],
            sessions: [],
            selectedOrder: {
                itemName: "",
                itemPrice: "",
                itemTotal: this.props.app.state.currencyName+" 0.00"
            },
            editingMenuItem: null,
            editingOrder: null,
        }

        if (paymentError) {
            this.error = paymentError
            paymentError = ''
        }

        this.onBackButtonClicked = this.onBackButtonClicked.bind(this)
        this.showEditDialog = this.showEditDialog.bind(this)
        this.confirmOrder = this.confirmOrder.bind(this)
        this.confirmAllOrder = this.confirmAllOrder.bind(this)
        this.cancelOrder = this.cancelOrder.bind(this)
        this.btnPlusClicked = this.btnPlusClicked.bind(this)
        this.btnMinusClicked = this.btnMinusClicked.bind(this)
        this.btnChoiceClicked = this.btnChoiceClicked.bind(this)
        this.btnAddOnClicked = this.btnAddOnClicked.bind(this)
        this.btnOptionClicked = this.btnOptionClicked.bind(this)
        this.updateOrderState = this.updateOrderState.bind(this)
        this.truePayBill = this.props.app.setVisibilityPayBill.bind(this, true)
        this.falsePayBill = this.props.app.setVisibilityPayBill.bind(this, false)

        this.confirmModalRef = React.createRef()
    }

    componentDidMount() {
        this.props.app.loadTableIfNull(this.props.tableId);
        if(this.getDraftOrders().length > 0) {
            this.falsePayBill();
        }
        else{
            this.truePayBill();
        }
        if(this.props.currencyName != null) {
            this.setState({
                selectedOrder: {
                itemName: "",
                itemPrice: "",
                itemTotal: this.props.currencyName+" 0.00"
                }
            })
        }
    }

    componentDidUpdate() {
        if (this.props.app.state.table_session == null && !this.props.app.state.table_session_loading && this.props.app.state.orders == null && !this.props.app.state.table_loading) {
            pageReload.goTo(`/category/${this.props.match.params.tableQR}`)
        }
        if (this.props.app.state.orders != null) {
            if (this.getDraftOrders().length > 0 && this.state.placeOrderButtonAnimation == null) {
                this.state.placeOrderButtonAnimation = setInterval(function () {
                    $('#place-order-button').fadeTo('slow', 0.5).fadeTo('slow', 1.0);
                }, 3000)
            } else if (this.getDraftOrders().length == 0 && this.state.placeOrderButtonAnimation != null) {
                clearInterval(this.state.placeOrderButtonAnimation)
            }
        } else if (this.state.placeOrderButtonAnimation != null) {
            clearInterval(this.state.placeOrderButtonAnimation)
        }

        ReactHelper.handleComponentDidUpdate(this, ["orders"], () => {
            if (this.getDraftOrders().length > 0) {
                this.falsePayBill();
            }
            else {
                this.truePayBill();
            }
        })
    }
    componentWillUnmount() {
        if (this.state.placeOrderButtonAnimation != null) {
            clearInterval(this.state.placeOrderButtonAnimation)
        }
    }

    onBackButtonClicked() {
        this.props.backClicked()
    }

    getTotalPriceString(order) {
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)

        let totalPrice = 0;
        let selectedChoices = this.props.app.state.variation.selectedChoices.filter((item) => item.item_id == order.menu_item_id)
        if (selectedChoices.length > 0) {
            selectedChoices.map((choice) => {
                totalPrice = parseFloat(choice.price);
            })
        }
        else {
            totalPrice = parseFloat(menuItem.price);
        }

        if ((this.props.app.state.variation.selectedAddOns || []).length > 0) {
            let selecteds = this.props.app.state.variation.selectedAddOns.filter((item) => item.item_id == order.menu_item_id)
            selecteds.map((addon) => {
                totalPrice = totalPrice + parseFloat(addon.price);
            })
        }

        if (order.take_away) {
            totalPrice = totalPrice + parseFloat(menuItem.take_away_charge)
        }

        totalPrice = totalPrice * order.newOrderQuantity
        let result = (totalPrice * 1).toFixed(2)
        return result
    }

    getTotalPrice(order) {
        return <span key={order.id} id="total-price" style={{ fontWeight: "bold" }}>{this.props.currencyName}&nbsp; {this.getTotalPriceString(order)}</span>
    }

    enterRemark(order) {
        let remarkId = "order-remark-" + order.id;
        return <input key={order.id} type="text" style={{ width: "260px" }} className="form-control" id={remarkId} maxLength="30" placeholder="Max 30 Character" defaultValue={order.remark} />
    }

    handleOrderQuantityChanged(order, change) {
        switch (change) {
            case "+":
                order.newOrderQuantity++
                break;
            case "-":
                // Handle make sure do not go zero
                order.newOrderQuantity -= (order.newOrderQuantity > 1) * 1
                break;
        }
        this.forceUpdate()
    }

    btnPlusClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let order = this.state.selectedOrder;//this.props.app.state.orders.find((item) => item.id == id)
        this.handleOrderQuantityChanged(order, '+')
    }

    btnMinusClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let order = this.state.selectedOrder;//this.props.app.state.orders.find((item) => item.id == id)
        this.handleOrderQuantityChanged(order, '-')
    }

    btnChoiceClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let order = this.state.selectedOrder
        let choice = this.props.app.state.variation.choices.find((item) => item.id == id)
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == choice.item_id)

        //Clear choice
        let variation = this.props.app.state.variation;
        let selectedChoice = []
        let i = 0
        for (i = 0; i < variation.selectedChoices.length; i++) {
            if (variation.selectedChoices[i].item_id != choice.item_id) {
                selectedChoice.push(variation.selectedChoices[i])
            }
        }

        let totalPrice = parseFloat(choice.price);
        totalPrice = totalPrice * order.newOrderQuantity;
        variation.totalPrice = totalPrice;

        this.props.app.setState({
            variation: variation
        })

        //update order label
        order.itemName = menuItem.name + " - " + choice.name
        order.itemPrice = this.props.currencyName+" " + (choice.price * 1).toFixed(2)

        this.setState({
            selectedOrder: order
        })
    }

    btnAddOnClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let order = this.state.selectedOrder
        let addon = this.props.app.state.variation.addons.find((item) => item.id == id)
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == addon.item_id)

        let check = this.props.app.state.variation.selectedAddOns.find((item) => item.id == id)
        if (check == null || check.length == 0) {
            let variation = this.props.app.state.variation;
            variation.selectedAddOns.push(addon);

            let totalPrice = parseFloat(menuItem.price) + parseFloat(addon.price);
            totalPrice = totalPrice * order.newOrderQuantity;
            variation.totalPrice = totalPrice;

            this.props.app.setState({
                variation: variation
            })
        }
        else {
            let res = []
            let totalPrice = parseFloat(menuItem.price);

            this.props.app.state.variation.selectedAddOns.forEach(function (selectedAddon) {
                if (selectedAddon.id != addon.id) {
                    res.push(selectedAddon)
                    totalPrice = totalPrice + parseFloat(selectedAddon.price)
                }
            });
            totalPrice = totalPrice * order.newOrderQuantity

            let variation = this.props.app.state.variation;
            variation.selectedAddOns = res;
            variation.totalPrice = totalPrice;

            this.props.app.setState({
                variation: variation
            })
        }
    }

    btnOptionClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let option = this.props.app.state.variation.options.find((item) => item.id == id)

        let check = this.props.app.state.variation.selectedOptions.find((item) => item.id == id)
        if (check == null || check.length == 0) {
            let variation = this.props.app.state.variation;
            variation.selectedOptions.push(option);

            this.props.app.setState({
                variation: variation
            })
        }
        else {
            let res = [];
            let variation = this.props.app.state.variation;
            this.props.app.state.variation.selectedOptions.forEach(function (selectedOption) {
                if (selectedOption.id != option.id)
                    res.push(selectedOption)
            });

            variation.selectedOptions = res;
            this.props.app.setState({
                variation: variation
            })
        }
    }

    getChoicesListing(order) {
        let listChoices = this.props.app.state.variation.choices
        listChoices.sort(function (a, b) { return a.sequence - b.sequence })
        let li = listChoices.filter(item => (item.item_id == order.menu_item_id)).map((choice) => {
            // let li = this.props.app.state.variation.choices.filter(item => (item.item_id == order.menu_item_id)).map((choice) => {
            let value = (choice.price > 0) ? " " + (choice.price * 1).toFixed(2) : " " + (choice.price * 1).toFixed(2);
            return (this.props.app.state.variation.selectedChoices.indexOf(choice) > -1) ?
                <button key={choice.id} data-id={choice.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-primary" onClick={this.btnChoiceClicked}>{choice.name + value}</button> :
                <button key={choice.id} data-id={choice.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-default" onClick={this.btnChoiceClicked}>{choice.name + value}</button>
        })
        return li
    }

    showEditDialog(order) {
        let orderItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)
        this.setState({
            editingMenuItem: orderItem,
            editingOrder: order
        })
    }

    cancelOrder(e) {
        e.stopPropagation()
        let me = this;
        let id = e.currentTarget.dataset.id * 1
        let order = this.props.app.state.orders.find((item) => item.id == id)

        let listClass = ".draft-order-" + order.id;
        $(listClass).slideUp('slow')

        let draftOrder = this.props.app.state.orders.filter((order) => order.order_status == "draft")
        let current = draftOrder.length - 1
        $('#tab-draft').text("Draft (" + current.toString() + ")")
        if (current == 0) {
            $('#place-order-button').hide();
        }

        $.ajax({
            url: "/orders/" + order.id,
            type: "patch",
            data: {
                update_order_status_only: 1,
                order_status: "cancelled",
            },
            success: function (response) {
                // me.forceUpdate()
            }
        })
    }

    updateOrderState(order) {
        order.order_status = "accepted"

        let orders = this.props.app.state.orders
        let index = orders.indexOf(order)
        if (index >= 0) {
            orders[index] = order;
        }

        if (this.getDraftOrders().length == 0) {
            //Change to confirm tab
            let tab = document.getElementById('tab-confirm');
            tab.click();
        }

        this.setState({
            orders: orders
        })
    }

    animationMove(e) {
        let id = e.currentTarget.dataset.id * 1
        let order = this.props.app.state.orders.find((item) => item.id == id)

        let img = $(e.target).closest('i');
        let bottom = img.offset().top - $('#tab-confirm').offset().top - 22;
        let right = img.offset().left - $('#tab-confirm').offset().left - 150;

        img.animate({
            bottom: bottom, right: right, opacity: '0.5', fontSize: "10px"
        },
            2000, function () {
                let listClass = ".draft-order-" + order.id;
                $(listClass).slideUp('slow', function () {
                    //Update amount
                    let confirmOrder = this.props.app.state.orders.filter((order) => order.order_status == "accepted")
                    let confirmCurrent = confirmOrder.length + 1
                    $('#tab-confirm').text(lang.confirmed + " (" + confirmCurrent.toString() + ")")

                    let draftOrder = this.props.app.state.orders.filter((order) => order.order_status == "draft")
                    let draftCurrent = draftOrder.length - 1
                    $('#tab-draft').text(lang.draft + " (" + draftCurrent.toString() + ")")
                    if (draftCurrent == 0) {
                        $('#place-order-button').hide();
                    }

                    //Update total price
                    let count = 0;
                    confirmOrder.forEach(order => {
                        count = count + parseFloat(order.order_total) //Other confirmed order
                    });

                    count = count + parseFloat(order.order_total) //Current confirmed order
                    $('#all-item-total-price').text('Total: '+this.props.currencyName+' ' + (count * 1).toFixed(2))

                    $('#tab-confirm').fadeOut(400, function () {
                        $('#tab-confirm').fadeIn(400);
                    });
                })
            }
        );
    }

    confirmOrder(e) {
        e.stopPropagation()
        let me = this;
        let id = e.currentTarget.dataset.id * 1
        let order = this.props.app.state.orders.find((item) => item.id == id)

        $.ajax({
            url: "/orders/" + order.id,
            type: "patch",
            data: {
                order_id: order.id,
                // merchant_id: order.merchant_id,
                table_id: order.table_id,
                quantity: order.quantity,
                remark: order.remark,
                variations: order.variations,
                order_total: order.order_total,
                desc: order.desc,
                take_away: order.take_away,
                order_status: "accepted"
            },
            success: function (response) {
                me.updateOrderState(order)
            }
        })

        this.animationMove(e);
    }

    confirmAllOrderAPI(confirmDialog) {
        confirmDialog.isLoading(true)
        $.ajax({
            url: `/orders/update_order_status`,
            type: 'post',
            data: {
                // order_id: order.id,
                merchant_id: this.props.app.state.table.merchant_id,
                table_id: this.props.app.state.table.id,
                order_status: "accepted"
            },
            success: (response) => {
                $('#place-order-button').fadeOut('slow');
                //Change to confirm tab
                let tab = $('#tab-confirm').click();
                alert(lang.confirm_order_msg);
                this.truePayBill();
            }
        })
        .always(() => {
            confirmDialog.close()
        })
        .fail((jqXHR) => {
            let json = JSON.parse(jqXHR.responseText);
            const message = json.message || lang.unable_to_place_order_order_manually;
            this.setState({
                errorMessage: message
            })
        })
    }

    confirmAllOrder(e) {
        let message = lang.asking_place_order.replace("<br>", "\n");
        this.setState({
            confirmModal: <ConfirmModal
                ref={this.confirmModalRef}
                pickup={this.props.app.state.table.pickup}
                message={message}
                buttonLayout="vertical"
                onClose={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
                onYes={() => {
                    this.confirmAllOrderAPI(this.confirmModalRef.current)
                }}
                onNo={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
            />
        })
    }

    getOrderDescription(order) {
        let me = this
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)

        return (
            (order.variation == null && order.remark == null && menuItem.take_away_charge < 0) ? null :
                <div className={'clearfix'} style={{ marginBottom: "5px" }}>
                    <div>
                        <div className={'pull-left'}>
                            <div className={'btn-group mr-2'} role="group" aria-label="Second group" style={{ display: "inline-block" }}>
                                <SelectedSideDishListing app={this.props.app} order={order} />
                                <SelectedVariationListing app={this.props.app} order={order} />
                                <span style={{ fontStyle:"italic", fontSize: "14px" , color: "red", display: order.remark ? "block" : "none" }}>{lang.remark + ": " + order.remark}</span>
                                {menuItem.take_away_charge < 0 || !order.take_away ? null :
                                    <span><span>&#10033;</span>{lang.take_away}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
        )
    }

    getMenuItemName(itemId) {
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == itemId)
        return menuItem.name;
    }

    showDraftOrderListing() {
        let me = this
        let index = 0

        if (!this.props.app.state.orders) {
            return;
        }

        let draftOrder = this.props.app.state.orders.filter((order) => order.order_status == "draft")
        if (draftOrder.length == 0) {
            return <div><p style={{ fontSize: "20px", transform: "translate(-50%, -50%)", position: "absolute", top: "50%", left: "50%" }}>{lang.clean_draft_order_desc}</p></div>
        }
        let merchantImage = this.props.app.getMerchantSettingValue('menu_item_user_mode_show_image') || null
        const { forceUseMerchantImage, allowUseMerchantImage, } = this.thumbnailImageOptions()
        let li = draftOrder.map((order) => {
            // order.item_name = me.getMenuItemName(order.menu_item_id)
            let listClass = "draft-order-" + order.id;
            let menuItem = this.props.app.state.menuItems.find(m => m.id == order.menu_item_id)
            index++;
            return (
                <div style={{position:"relative"}} className={listClass} key={listClass}>
                    <li className={' list-group-item clearfix'} data-index={index} style={{ verticalAlign: "middle", backgroundColor: "rgba(255, 255, 255, 0.8)", }} key={order.id} data-id={order.id}>
                        <div style={{display:"flex"}}>
                            {/*
                                +----------------------------------------------+
                                |       | Item Name                  | Buttons |
                                |  Img  |   - Side Dishes            |         |
                                |       |   - Options                |         |
                                |       |----------------------------+---------|
                                |       |                     Quantity  Price  |
                                +-------+--------------------------------------+
                            */}


                            {/* Left section for thumbnail image */}
                            {merchantImage != 0 && <MenuItemThumbnailImage menuItem={menuItem} allowUseMerchantImage={allowUseMerchantImage} forceUseMerchantImage={forceUseMerchantImage} />}

                            {/* Right section for item description, buttons, quantity and price */}
                            <div style={{flex: "1 0 100px", flexDirection: "column"}}>

                                {/* Top column for item description and buttons */}
                                <div style={{display: "flex"}}>
                                    {/* Left section of top column for item descriptions */}
                                    <div style={{marginLeft: "10px", flex: "1 0 100px"}}>
                                        <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                                            {order.desc}
                                        </div>
                                        <span>
                                            {this.props.currencyName+" " + (order.order_total * 1).toFixed(2)}
                                        </span>
                                        {this.getOrderDescription(order)}
                                    </div>

                                    {/* Right section of top section for buttons */}
                                    <div style={{ display: "table-cell", flex: "0 0 110px", textAlign: "right"}}>
                                            <button className="far fa-edit fa-2x edit-icon" style={{
                                                border: "none",
                                                backgroundColor: "transparent",
                                                width: "40px",
                                                marginTop: "10px",
                                            }} onClick={() => { me.showEditDialog(order) }}/>
                                            <button className="fas fa-times fa-2x delete-icon" style={{
                                                border: "none",
                                                backgroundColor: "transparent",
                                                width: "40px",
                                                marginTop: "10px",
                                            }} data-id={order.id} onClick={me.cancelOrder}/>
                                    </div>
                                </div>

                                {/* Bottom column for quantity and price */}
                                <div>
                                    <div className="" style={{display: "flex", flexDirection: "row-reverse"}}>
                                        {/* First item from right = Price */}
                                        <p style={{
                                            flex: "0 1 80px",
                                            textAlign: "right",
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                            margin: "auto",
                                            }}>
                                            {this.props.currencyName+" " + (order.order_total * 1).toFixed(2)}
                                        </p>

                                        {/* Second item from right = Quantity */}
                                        <div style={{
                                                flex: "0 1 auto",
                                                border: "1px solid #d3d3d3",
                                                width:"35px", height: "35px",
                                                textAlign: "center",
                                                borderRadius:"5px",
                                                margin: "auto",
                                                }}>
                                                {order.quantity}
                                        </div>

                                        {/* Third dummy item to fill up all available empty space to "push"
                                        other items towards the right */}
                                        <div style={{flex: "1 0 100px"}}>&nbsp;</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    {
                        order.order_by == OrderBy.ADMIN &&
                        <div style={{position:"absolute", left:"5px", bottom:"0px", fontSize: "8pt"}}>
                            {lang.order_by_admin}
                        </div>
                    }
                </div>
            )
        })
        return li
    }

    thumbnailImageOptions = () => {
        const forceUseMerchantImage = this.props.app.isMerchantHasFeature('force_use_merchant_menu_item_image_as_default_user_menu_item_image')
        const allowUseMerchantImage = this.props.app.isMerchantHasFeature('use_merchant_menu_item_image_as_default_user_menu_item_image')
        return { forceUseMerchantImage, allowUseMerchantImage, }
    }

    showConfirmOrderListing() {
        let me = this
        let index = 0
        let merchantImage = this.props.app.getMerchantSettingValue('menu_item_user_mode_show_image') || null
        const { forceUseMerchantImage, allowUseMerchantImage, } = this.thumbnailImageOptions()

        if (!this.props.app.state.orders || !this.props.app.state.menuItems) {
            return;
        }

        let confirmOrder = this.props.app.state.orders.filter((order) => order.order_status == "accepted")
        let li = confirmOrder.map((order) => {
            // order.item_name = me.getMenuItemName(order.menu_item_id);
            let listClass = "confirm-order-" + order.id;
            let menuItem = this.props.app.state.menuItems.find(m => m.id == order.menu_item_id)
            index++;
            return (
                <div className={listClass} key={listClass}>
                    <li className={'list-group-item clearfix'} data-index={index} style={{ verticalAlign: "middle", backgroundColor: "rgba(255, 255, 255, 0.8)", }} key={order.id} data-id={order.id}>
                        <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            {merchantImage != 0 && <MenuItemThumbnailImage menuItem={menuItem} allowUseMerchantImage={allowUseMerchantImage} forceUseMerchantImage={forceUseMerchantImage} />}
                                <span style={{ marginLeft: "5px" }}>
                                    {order.quantity + "x " + order.desc}
                                </span>
                            <div className="pull-right" style={{ marginTop: "15px" }}>{this.props.currencyName+" " + (order.order_total * 1).toFixed(2)}</div>
                        </div>
                        {this.getOrderDescription(order)}
                    </li>
                </div>
            )
        })
        if (OrderUtil.isNeedShowBottomHint(li.length)) {
            index++
            li.push(<PayBillHint key={index} app={this.props.app}/>)
        }
        return li
    }

    getOrderTabs() {
        let me = this
        if (!this.props.app.state.orders) {
            return;
        }

        if (this.getDraftOrders().length > 0) {
            return (
                <div>
                    {/* <h3>{lang.my_order} <span className="pull-right">{lang.total}: RM {(count * 1).toFixed(2)}</span></h3> */}
                    <ul className="nav nav-tabs" style={{ marginTop: "15px" }}>
                        <li className="active tab-orders"><a onClick={this.falsePayBill} id="tab-draft" data-toggle="tab" href="#tabDraft"><span className="fas fa-clipboard-list fa-2x" style={{marginTop: "auto", marginBottom: "auto", marginRight: "10px"}}></span>{lang.draft + " (" + this.getDraftOrders().length + ")"}</a></li>
                        <li className="tab-orders"><a onClick={this.truePayBill} id="tab-confirm" data-toggle="tab" href="#tabConfirmed"><span className="fas fa-clipboard-check fa-2x" style={{marginTop: "auto", marginBottom: "auto", marginRight: "10px"}}></span>{lang.confirmed + " (" + this.getConfirmedOrders().length + ")"}</a></li>
                        {/* <button style={{ display: draftOrder.length > 0 ? "initial" : "none" }} id="place-order-button" data-id={orderId} key={orderId} className="btn btn-danger pull-right" onClick={this.confirmAllOrder}><strong>{lang.place_all_order}</strong></button> */}
                    </ul>
                </div>
            )
        }
        else {
            return (
                <div>
                    <ul className="nav nav-tabs" style={{ marginBottom: "-1px" }}>
                        <li className="tab-orders"><a onClick={this.falsePayBill} id="tab-draft" data-toggle="tab" href="#tabDraft"><span className="fas fa-clipboard-list fa-2x" style={{marginTop: "auto", marginBottom: "auto", marginRight: "10px"}}></span>{lang.draft + " (" + this.getDraftOrders().length + ")"}</a></li>
                        <li className="active tab-orders"><a onClick={this.truePayBill} id="tab-confirm" data-toggle="tab" href="#tabConfirmed"><span className="fas fa-clipboard-check fa-2x" style={{marginTop: "auto", marginBottom: "auto", marginRight: "10px"}}></span>{lang.confirmed + " (" + this.getConfirmedOrders().length + ")"}</a></li>
                    </ul>
                </div>
            )
        }
    }

    isColorSet() {
        if(this.props.app.isMerchantHasFeature('change_button_color_theme_at_user_order_page')){
            return this.props.app.getMerchantSettingValue('change_button_color_theme_at_user_order_page', null, "#2ab27b")
        }
    }

    showTabs() {
        let confirmOrderListing = (isActivePane) => <div id="tabConfirmed" className={`tab-pane fade ${isActivePane && "active in"}`}>
            <li id="draft_order_desc" style={{
                        width:"100%",
                        lineHeight: "35px",
                        backgroundColor: "#fef3df",
                        listStyleType: "none",
                        textAlign: "center",
                        fontSize: "15px",
                    }}><span>&#10033;</span>{this.props.app.isMerchantHasFeature('hide_pay_bill') ? lang.confirm_order_desc_no_pay_bill : lang.confirm_order_desc}</li>
            <ul className="list-group">{this.showConfirmOrderListing()}</ul>
        </div>
        if (this.getDraftOrders().length > 0) {
            return (
                <div className="tab-content" style={{marginTop:"-10px"}}>
                    <div id="tabDraft" className="tab-pane fade in active">
                    <li id="draft_order_desc" style={{
                        width:"100%",
                        lineHeight: "35px",
                        backgroundColor: "#fef3df",
                        listStyleType: "none",
                        textAlign: "center",
                        fontSize: "15px",
                    }}><span>&#10033;</span>{lang.draft_order_desc}</li>
                        <ul className="list-group" style={{height: "50vh", overflowY:"auto"}}>
                            {this.showDraftOrderListing()}
                        </ul>
                        <li style={{display: "flex", marginTop: "10px", marginBottom: "10px",}}>
                                <span style={{
                                    lineHeight: "35px",
                                    listStyleType: "none",
                                    fontSize: "16px",
                                    float: "left",
                                    marginLeft: "15px",
                                }}>
                                {lang.order_total.toUpperCase()}
                                </span>
                                <strong className="order-total-price" style={{fontWeight: "bold", fontSize: "20px", position: "absolute",right: "10px",}}>{this.props.app.state.currencyName}&nbsp; {(this.getDraftOrderTotal() * 1).toFixed(2)}</strong>
                        </li>
                        <div style={{display:"flex", justifyContent:"center",}}>
                            <button type="button" style={{ display: "initial", width: "75%", marginTop: "15px" , backgroundColor: this.isColorSet() || "#f9a022", borderRadius: "50px", border: "none",}} id="place-order-button" className="btn btn-success"
                                onClick={this.props.app.state.table.pickup ?
                                    () => this.props.history.push(`/pickup/${this.props.match.params.tableQR}`) :
                                    this.confirmAllOrder}>
                                <img style={{ width: "35px", height: "35px" }} src="/Icon/checkout.png"/>
                                <strong style={{ color: "white", fontSize: "16px", marginLeft: "10px", }}>
                                    {this.isPickupOrDelivery() ? lang.proceed_to_checkout.toUpperCase() : lang.place_all_order.toUpperCase()}
                                </strong>
                            </button>
                        </div>
                    </div>
                    {confirmOrderListing()}
                </div>
            )
        }
        else {
            return (
                <div className="tab-content">
                    <div id="tabDraft" className="tab-pane fade">
                        <ul className="list-group">{this.showDraftOrderListing()}</ul>
                    </div>
                    {confirmOrderListing(true)}
                </div>
            )
        }
    }

    getComfirmedOrderTotal() {
        return Order.getConfirmedOrderTotal()
    }

    getConfirmedOrders() {
        return this.props.app.state.orders.filter((order) => order.order_status == "accepted")
    }

    getDraftOrderTotal() {
        let count = 0
        this.getDraftOrders().forEach(order => {
            count = count + parseFloat(order.order_total)
        });
        return count
    }

    getDraftOrders() {
        let orders = (this.props.app.state.orders || []).filter((order) => order.order_status == "draft")
        return orders
    }

    bill() {
        Order.payBill()
    }
    isPickupOrDelivery = () => {
        return (this.props.app.state.table.table_type_bitwise & (TableType.BIT_PICKUP | TableType.BIT_DELIVERY)) > 0
    }
    render() {
        if (!table_session_id) {
            return <Redirect to={`/${this.props.match.params.tableQR}`} />
        }
        if (!this.props.app.isReadyFor(this)) {
            return (<div></div>);
        }
        let image_path = (this.props.app.state.merchant && this.props.app.state.merchant.logo_url)?this.props.app.state.merchant.display_logo : "";
        let styling = this.props.app.isMerchantHasFeature('show_background_image_in_user_app')
        return (
            <div>
                {styling && <img src={image_path} style={{ position: "absolute", bottom: "50%", left: "50%", marginLeft: "-125px", marginBottom: "-125px", width: "250px", height: "250px", opacity: "0.4", zIndex: "0" }}/>}
                {this.state.confirmModal}
                {this.state.errorMessage && <MessageModal message={this.state.errorMessage} onClose={() => this.setState({errorMessage: null})}/> }
                {
                    this.state.editingMenuItem == null ? '' :
                        <MenuItemModal
                            app={this.props.app}
                            isPickupOrDelivery={this.isPickupOrDelivery()}
                            menuItem={this.state.editingMenuItem}
                            order={this.state.editingOrder}
                            onClose={() => { this.setState({ editingMenuItem: null, editingOrder: null }) }}
                        />
                }
                <TopNav
                    tableQR={this.props.match.params.tableQR}
                    title={lang.order}
                    table={this.props.app.state.table}
                    action={this.showDialog}
                    backButton={true}
                    backLabel={lang.back} back={`/category/${this.props.match.params.tableQR}`}
                />
                {this.error && <div className='alert alert-danger' style={{ padding: '10px', margin: "60px 10px 10px 10px"}}>
                    {lang.payment_failure.replace('{error}', this.error)}
                </div>}
                <div style={{ paddingTop: '50px', marginBottom: "10px", backgroundColor: "white" }}>
                    {this.getOrderTabs()}
                </div>
                {/* <div className="container bottom-nav-padding"> */}
                <div>
                    <div style={{ display: "block" }}>
                        {this.showTabs()}
                    </div>
                </div>
            </div>
        )
    }
}

class OrderItemOptions extends React.Component {
    render() {
        let inlineBlock = { display: "inline-block" }

        return (
            <div className={'clearfix'} style={{ marginBottom: "5px" }}>
                <div>
                    {this.props.isSelected ? <span style={{ color: this.props.fontColor }}>{this.props.title}</span> : <span>{this.props.title}</span>}
                    <div className={'pull-right'}>
                        <div className={'btn-group mr-2'} role="group" aria-label="Second group" style={inlineBlock}>
                            {this.props.body}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NewOrderContent;

var OrderBody = {
    show: function (table, orders, menuItems, variations) {
        ReactDOM.render(
            <NewOrderContent table={table} orders={orders} menuItems={menuItems} variations={variations} />,
            $('#react-app')[0]
        )
    }
}